import { motion, useReducedMotion } from "framer-motion";
import { Overline, Reveal } from "./Reveal";

const STEPS = [
  { number: "01", name: "Diagnóstico", desc: "Entendemos o negócio, os objetivos, o público e os desafios atuais." },
  { number: "02", name: "Estratégia", desc: "Definimos prioridades, estrutura digital, canais e indicadores relevantes." },
  { number: "03", name: "Implementação", desc: "Construímos páginas, configuramos campanhas e implementamos as ferramentas de mensuração contratadas." },
  { number: "04", name: "Análise e Evolução", desc: "Avaliamos os dados disponíveis, identificamos oportunidades de melhoria e ajustamos a estratégia." },
];

export const Methodology = () => {
  const reduce = useReducedMotion();
  return (
    <section id="metodologia" data-testid="methodology-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal>
          <Overline>Como trabalhamos</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl">
            Metodologia <span className="chrome-text">GOBAX</span>
          </h2>
        </Reveal>

        <div className="relative mt-20">
          <div aria-hidden="true" className="absolute left-0 right-0 top-0 h-px bg-white/10" />
          <motion.div
            aria-hidden="true"
            className="absolute left-0 top-0 h-px origin-left bg-gradient-to-r from-gb-silverhi via-gb-silver to-gb-silver/20"
            initial={reduce ? { scaleX: 1 } : { scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
            style={{ width: "100%" }}
          />
          <ol className="grid gap-12 pt-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            {STEPS.map((step, i) => (
              <Reveal key={step.number} delay={0.12 * i}>
                <li data-testid={`methodology-step-${i + 1}`} className="group">
                  <span className="chrome-text font-display text-6xl font-extrabold leading-none lg:text-7xl">
                    {step.number}
                  </span>
                  <h3 className="mt-6 font-display text-lg font-bold uppercase tracking-[0.12em]">
                    {step.name}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-gb-gray">{step.desc}</p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
